import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { AppState } from '../../core/redux/appState';
import { Action } from 'redux';
import { ReportRecipientReport } from '../models';
import { toIndexAwareMap } from '../../language/arrays';


type SetSelectedAction = {
  type: ActionType.SetSelected;
  report: ReportRecipientReport;
  selected: boolean;
}


/**
 * Dispatch this to update the selected status for an individual report.
 * @param selected - the new selected state you want (default: false)
 */
export const setSelectedAction = (report: ReportRecipientReport, selected: boolean): SetSelectedAction => ({
  type:     ActionType.SetSelected,
  report:   report,
  selected: selected,
});


export const setSelectedReducer = (state: AppState, incomingAction: Action): AppState => {
  if (incomingAction.type !== ActionType.SetSelected) {
    return state;
  }
  
  const action = incomingAction as SetSelectedAction;

  const reports = toIndexAwareMap(state.reportRecipientReports || [], r => `${r.participantReportId}`);
  const selectedReport = reports[`${action.report.participantReportId}`];
  const updatedReport = R.assoc('isChecked', action.selected, selectedReport);
  const updatedReports = R.assoc(`${action.report.participantReportId}`, updatedReport, reports);
  return R.assoc('reportRecipientReports',
    Object.values(updatedReports).sort((a, b) => a.sourceIndex - b.sourceIndex),
    state);  
};